var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6717_7302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38427 18C3.24395 18 3.17455 17.8296 3.27495 17.7315L8.4955 12.6344C8.54207 12.5914 8.56798 12.5346 8.56798 12.4756C8.56798 12.4165 8.54207 12.3597 8.4955 12.3167L3.27799 7.26895C3.1769 7.17114 3.24613 7 3.3868 7H5.97321C6.01328 7.0011 6.05268 7.00924 6.08902 7.02395C6.12535 7.03866 6.15786 7.05962 6.18457 7.08556L11.5955 12.3167C11.6412 12.3577 11.6667 12.4124 11.6667 12.4694C11.6667 12.5264 11.6412 12.5812 11.5955 12.6222L6.18457 17.8656C6.16453 17.9011 6.13483 17.932 6.09801 17.9554C6.06119 17.9788 6.01836 17.9941 5.97321 18H3.38427Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6717_7302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82585 18C7.68554 18 7.61614 17.8296 7.71654 17.7315L12.9371 12.6344C12.9837 12.5914 13.0096 12.5346 13.0096 12.4756C13.0096 12.4165 12.9837 12.3597 12.9371 12.3167L7.71958 7.26895C7.61849 7.17114 7.68772 7 7.82839 7H10.4148C10.4549 7.0011 10.4943 7.00924 10.5306 7.02395C10.5669 7.03866 10.5995 7.05962 10.6262 7.08556L16.0371 12.3167C16.0828 12.3577 16.1083 12.4124 16.1083 12.4694C16.1083 12.5264 16.0828 12.5812 16.0371 12.6222L10.6262 17.8656C10.6061 17.9011 10.5764 17.932 10.5396 17.9554C10.5028 17.9788 10.4599 17.9941 10.4148 18H7.82585Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6717_7302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2675 18C12.1272 18 12.0578 17.8296 12.1582 17.7315L17.3787 12.6344C17.4253 12.5914 17.4512 12.5346 17.4512 12.4756C17.4512 12.4165 17.4253 12.3597 17.3787 12.3167L12.1612 7.26895C12.0601 7.17114 12.1294 7 12.27 7H14.8564C14.8965 7.0011 14.9359 7.00924 14.9723 7.02395C15.0086 7.03866 15.0411 7.05962 15.0678 7.08556L20.4788 12.3167C20.5244 12.3577 20.5499 12.4124 20.5499 12.4694C20.5499 12.5264 20.5244 12.5812 20.4788 12.6222L15.0678 17.8656C15.0478 17.9011 15.0181 17.932 14.9812 17.9554C14.9444 17.9788 14.9016 17.9941 14.8564 18H12.2675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6717_7302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(3 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6717_7302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(7.44159 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6717_7302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(11.8832 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass3);
export default __webpack_public_path__ + "static/media/class-3.267302c2d5811359bf59e44b8c8669e9.svg";
export { ForwardRef as ReactComponent };